window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    
    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() { 
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant.options[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();
      console.log("VARIANT CHANGE", variant);

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  console.log("HI PRODUCT JS!");
  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productTitle: '#product-title',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);
    this.namespace = '.product';
    this.productTitleResizeTimeout = null;

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || true,
      singleOptionSelector: selectors.singleOptionSelector, 
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
    this.fitProductTitle();
    $(window).on('resize' + this.namespace, this.fitProductTitle.bind(this));

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(this.fitProductTitle.bind(this));
    }

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    fitProductTitle: function() {
      var title = $(selectors.productTitle, this.$container)[0];

      if (!title) {
        return;
      }

      clearTimeout(this.productTitleResizeTimeout);
      this.productTitleResizeTimeout = setTimeout(function() {
        title.style.removeProperty('--product-title-font-size');

        if (!title.clientWidth || title.scrollWidth <= title.clientWidth + 1) {
          return;
        }

        var computedStyle = window.getComputedStyle(title);
        var maxFontSize = parseFloat(computedStyle.fontSize);
        var minFontSize = Math.max(maxFontSize * 0.55, 24);
        var low = minFontSize;
        var high = maxFontSize;

        for (var i = 0; i < 8; i++) {
          var mid = (low + high) / 2;
          title.style.setProperty('--product-title-font-size', mid + 'px');

          if (title.scrollWidth > title.clientWidth + 1) {
            high = mid;
          } else {
            low = mid;
          }
        }

        title.style.setProperty('--product-title-font-size', low + 'px');
      }, 60);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
      $(window).off(this.namespace);
      clearTimeout(this.productTitleResizeTimeout);
    }
  });

  return Product;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


/*================ WCS ================*/
//CM SCRIPTS
$(document).ready(function() {

  //Sticky Header
  if (!$('div#shopify-section-header .nav-header').hasClass("solid")) {
    console.log('dynamic header...');
    var top_offset = $(window).scrollTop();
    if (top_offset > 3) {
      $('div#shopify-section-header .nav-header').addClass('scrolled');
    }
    $(window).scroll(function() {
        var top_offset = $(window).scrollTop();
        // console.log(top_offset)
        if (top_offset <= 3) {
          $('div#shopify-section-header .nav-header').removeClass('scrolled');
        } else {
          $('div#shopify-section-header .nav-header').addClass('scrolled');
        }
    });
  } else {
    console.log('static header...');
  }

  //AJAX Product Filter
  $('.catalog-filters .filter-check').change(function() {
    var tag = $(this).attr('id');
    var checkList = [];
    $('.catalog-filters-wrap input[type=checkbox]:checked').each(function() {
       checkList.push($(this).attr('id'));
     });
    var len = $('.catalog-filters-wrap input[type=checkbox]:checked').length;
    if(len > 0) {
      console.log(tag + ' filter activated');
      var filterList = "";
      $.each(checkList, function (index, value) {
        filterList = filterList.concat(value+"+");
      });
      $('.catalog-product-grid').attr('data-filters', filterList);
      $('.catalog-product-grid .unfiltered').addClass('hidden');
      $('.catalog-product-grid .filtered').remove();
      getFilterCreate(filterList);
      $('.pagination').hide();
    } else if (len == 0) {
      console.log('filters cleared');
      $('.catalog-product-grid').attr('data-filters', "none");
      $('.catalog-product-grid .filtered').remove();
      $('.catalog-product-grid .unfiltered, label, .catalog-filters-wrap .catalog-filters ul li.hidden').removeClass('hidden');
      hideShowFilterBlocks();
      $('.pagination').show();
    }
  });

 
  //Temporary Catalog Product Link Wrapping
  $(document).on('click','.catalog-product-overlay', function(e) {
    if (!$(e.target).hasClass('quick-shop-launch')) {
      window.location = $(this).parent().find("p a").attr("href");
      return false;
    }
  });

    //Init Animate-On-Scroll (AOS)
  AOS.init({
   duration: 750,
   easing: 'ease',
   delay: 100,
   once: true,
   disable: inIframe(),
  });
  if (inIframe()) { //Hack to prevent AOS elements from disappearing when theme editor change occurs
    var css = '[data-aos] { opacity: 1 !important; transform: none !important; }',
    head = document.head || document.getElementsByTagName('head')[0],
    style = document.createElement('style');

    style.type = 'text/css';
    if (style.styleSheet){
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }

    head.appendChild(style);
  }

  //Hero Scroll Down Button
  $(document).on('click', '.slide-down-button', function(event){
    event.preventDefault();
    event.stopImmediatePropagation();
    // var viewportHeight = $(window).height() - 70; //70px is the height of the header
    if ($('.about-hero').length) {
      var heroHeight = $('.about-hero').height() - 100;
    } else if ($('#shopify-section-home-hero')) {
      var heroHeight = $('#shopify-section-home-hero').height() - 100;
    }
    $('html').animate({
        scrollTop: heroHeight,
        complete: function () {
            console.log('auto-scrolled');
        }
    }, 250); 
    return false;
  });


  //Product Thumbnails
  // $('.product-thumbs li a').on('mouseenter click', function(e) {
  //   e.preventDefault();
  //   currImage = $('.featured-image').attr('src');
  //   thumbSrc = $(this).attr('href');
  //   if (thumbSrc != currImage) {
  //     $('.featured-image').fadeTo(200,0.25, function() {
  //       $('.featured-image').attr('src', thumbSrc);
  //     }).fadeTo(200,1);
  //   }
  //   return false;
  // });

  //Init CartJS
  CartJS.init(cart_json);

  //Cart Drop Down
  // var cart_hide;
  // $('a.nav-cart, span.item-count, #cart-drop').on('mouseenter', function(e){
  //   clearTimeout(cart_hide);
  //   $( '#cart-drop' ).addClass( "show" );
  // });
  // $('a.nav-cart, span.item-count, #cart-drop').on('mouseleave', function(e){
  //   cart_hide = setTimeout(function () {
  //       $( '#cart-drop' ).removeClass( "show" );
  //   }, 1000);
  // });

  //Cart Drawer
  // $('#offCanvas').offcanvas({
  //   modifiers: 'right, overlay', // default options
  //   triggerButton: '#triggerButton', // btn to open offcanvas
  //   closeButtonClass: 'cart-close'
  // });
  $( document ).trigger( "enhance" );

  var originalText = '';
  var shouldShowAddToCartNotification = false;
  var pendingAddToCartVariantId = null;

  function normalizeVariantId(variantId) {
    if (variantId === undefined || variantId === null) {
      return null;
    }

    var match = variantId.toString().match(/\d+/);
    if (!match || !match[0]) {
      return null;
    }

    var parsed = parseInt(match[0], 10);
    return isNaN(parsed) ? null : parsed;
  }

  function queueAddToCartNotification(variantId) {
    if (window.location.pathname.indexOf('/products/') === -1) {
      return;
    }

    shouldShowAddToCartNotification = true;
    pendingAddToCartVariantId = normalizeVariantId(variantId);
  }

  function getKlevuCardCartVariant(cart, variantId) {
    var normalizedVariantId = normalizeVariantId(variantId);
    var result = {
      item: null,
      line: null,
      quantity: 0
    };

    if (!normalizedVariantId || !cart || !Array.isArray(cart.items)) {
      return result;
    }

    cart.items.forEach(function(item, index) {
      var itemVariantId = normalizeVariantId(item.variant_id || item.id);

      if (itemVariantId !== normalizedVariantId) {
        return;
      }

      result.quantity += parseInt(item.quantity, 10) || 0;

      if (!result.item) {
        result.item = item;
        result.line = index + 1;
      }
    });

    return result;
  }

  function getKlevuCardSelectedVariantId($form) {
    return $form.find('select[name="id"] option:selected').val() || $form.find('[name="id"]').val();
  }

  function getKlevuCardSelectedMaxQuantity($form) {
    var rawMax = $form.find('select[name="id"] option:selected').attr('data-adjusted-inventory');

    if (rawMax === undefined || rawMax === '') {
      return null;
    }

    var parsedMax = parseInt(rawMax, 10);
    return isNaN(parsedMax) ? null : parsedMax;
  }

  function setKlevuCardBusy($form, isBusy) {
    $form.toggleClass('is-cart-updating', isBusy);
    $form.find('[data-klevu-cart-action]').prop('disabled', isBusy);
    $form.find('[data-klevu-card-cart-quantity]').prop('disabled', isBusy);
  }

  function updateKlevuCardCartQuantity($form, requestedQuantity) {
    if (!window.CartJS) {
      return;
    }

    var variantId = getKlevuCardSelectedVariantId($form);
    var cartVariant = getKlevuCardCartVariant(CartJS.cart, variantId);
    var maxQuantity = getKlevuCardSelectedMaxQuantity($form);
    var currentLineQuantity = cartVariant.item ? (parseInt(cartVariant.item.quantity, 10) || 0) : 0;
    var nextQuantity = parseInt(requestedQuantity, 10);

    if (!cartVariant.line || isNaN(nextQuantity)) {
      syncKlevuProductCard($form, CartJS.cart);
      return;
    }

    nextQuantity = Math.max(0, nextQuantity);

    if (maxQuantity !== null && nextQuantity > maxQuantity) {
      alert('No additional quantity available for this item');
      nextQuantity = maxQuantity;
    }

    var nextLineQuantity = Math.max(0, currentLineQuantity + (nextQuantity - cartVariant.quantity));

    setKlevuCardBusy($form, true);
    CartJS.updateItem(cartVariant.line, nextLineQuantity);
  }

  function syncKlevuProductCard($form, cart) {
    var variantId = getKlevuCardSelectedVariantId($form);
    var cartVariant = getKlevuCardCartVariant(cart, variantId);
    var currentQuantity = cartVariant.quantity || 0;
    var maxQuantity = getKlevuCardSelectedMaxQuantity($form);
    var isInCart = currentQuantity > 0;
    var wasInCart = $form.attr('data-klevu-card-in-cart') === 'true';

    if (wasInCart && !isInCart) {
      $form.find('[data-klevu-card-quantity-input] input.quantity').val(1);
    }

    $form.attr('data-klevu-card-in-cart', isInCart ? 'true' : 'false');
    $form.data('klevuCartLine', cartVariant.line || '');
    $form.data('klevuCartQuantity', currentQuantity);
    $form.find('[data-klevu-card-cart-quantity]').val(currentQuantity);
    if (maxQuantity === null) {
      $form.find('[data-klevu-card-cart-quantity]').removeAttr('max');
    } else {
      $form.find('[data-klevu-card-cart-quantity]').attr('max', maxQuantity);
    }
    $form.find('.buy-now-button').prop('hidden', isInCart);
    $form.find('[data-klevu-card-quantity-input]').prop('hidden', isInCart);
    $form.find('[data-klevu-card-cart-controls]').prop('hidden', !isInCart);
    setKlevuCardBusy($form, false);
    $form.find('[data-klevu-cart-action="increase"]').prop('disabled', maxQuantity !== null && currentQuantity >= maxQuantity);
  }

  function syncKlevuProductCards(cart) {
    var cartState = cart || (window.CartJS && CartJS.cart);

    $('[data-klevu-card-cart-form]').each(function() {
      syncKlevuProductCard($(this), cartState);
    });
  }

  window.syncKlevuProductCards = syncKlevuProductCards;
  var klevuProductCardSyncTimer = null;

  function scheduleKlevuProductCardSync() {
    window.clearTimeout(klevuProductCardSyncTimer);
    klevuProductCardSyncTimer = window.setTimeout(function() {
      syncKlevuProductCards();
    }, 50);
  }

  function nodeHasKlevuCardForm(node) {
    if (!node || node.nodeType !== 1) {
      return false;
    }

    return (node.matches && node.matches('[data-klevu-card-cart-form]')) ||
      (node.querySelector && node.querySelector('[data-klevu-card-cart-form]'));
  }

  $(document).on('cart.ready', function(event, cart) {
    syncKlevuProductCards(cart);
  });

  $(document).on('change', '[data-klevu-card-cart-form] select[name="id"]', function() {
    syncKlevuProductCard($(this).closest('[data-klevu-card-cart-form]'), window.CartJS && CartJS.cart);
  });

  $(document).on('click', '[data-klevu-cart-action]', function(e) {
    e.preventDefault();
    e.stopPropagation();

    if (!window.CartJS) {
      return;
    }

    var $form = $(this).closest('[data-klevu-card-cart-form]');
    var action = $(this).attr('data-klevu-cart-action');
    var currentQuantity = parseInt($form.data('klevuCartQuantity'), 10) || 0;
    var nextQuantity = currentQuantity;

    if (action === 'increase') {
      nextQuantity = currentQuantity + 1;
    } else if (action === 'decrease') {
      nextQuantity = Math.max(0, currentQuantity - 1);
    } else if (action === 'remove') {
      nextQuantity = 0;
    }

    updateKlevuCardCartQuantity($form, nextQuantity);
  });

  $(document).on('focus', '[data-klevu-card-cart-quantity]', function() {
    this.select();
  });

  $(document).on('keydown', '[data-klevu-card-cart-quantity]', function(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      this.blur();
    }
  });

  $(document).on('change', '[data-klevu-card-cart-quantity]', function() {
    updateKlevuCardCartQuantity($(this).closest('[data-klevu-card-cart-form]'), $(this).val());
  });

  $(document).ready(function() {
    syncKlevuProductCards(window.CartJS && CartJS.cart);

    if (window.MutationObserver && document.body) {
      var klevuProductCardObserver = new MutationObserver(function(mutations) {
        var shouldSync = mutations.some(function(mutation) {
          return Array.prototype.some.call(mutation.addedNodes, nodeHasKlevuCardForm);
        });

        if (shouldSync) {
          scheduleKlevuProductCardSync();
        }
      });

      klevuProductCardObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  });
  function isMainProductAddToCartButton(button) {
    if (!button || window.location.pathname.indexOf('/products/') === -1) {
      return false;
    }

    if (button.id === 'free-addon-button') {
      return false;
    }

    return button.id === 'addtocart' || $(button).closest('#sticky-select').length > 0;
  }
  //AJAX Add To Cart
  $(document).on('click', '.add-to-cart-button', function(e) {
    if (!isMainProductAddToCartButton(this)) {
      return;
    }

    console.log('add-to-cart click');
    originalText = $(this).val();
    $(this).val('Updating...');
    var id = $('select.variant-select option:selected').attr('data-id');
    if (id === undefined) { $('select.variant-select option:selected').attr('data-variant-id'); }
    var quantity = $(".product-quantity-picker input#Quantity").val();
    var exStock = $('select.variant-select option:selected').attr('ex-stock');
    var exDelay = $('select.variant-select option:selected').attr('ex-delay');
    var properties = {};
    if (quantity > 0) {
        if ($('span.shipping-restriction').length > 0) { properties["Shipping Restriction"] = "USA"; }
        if ($('.preorder-notification').text().length > 0) { properties["_preorder"] = "TRUE"; }
        if (exStock !== undefined) { 
          properties["_make-item"] = "TRUE"; 
        }
        if (exStock !== undefined && exDelay !== undefined) {
          properties["_delay"] = "TRUE";
        }
        // Gift card form integration
        var $recipientForm = $('recipient-form');
        var isRecipientChecked = $recipientForm.find('input[type="checkbox"]').is(':checked');

        if (isRecipientChecked) {
          properties["__shopify_send_gift_card_to_recipient"] = "on";
          properties["Recipient email"] = $recipientForm.find('input[name="properties[Recipient email]"]').val() || '';
          properties["Recipient name"] = $recipientForm.find('input[name="properties[Recipient name]"]').val() || '';
          properties["Message"] = $recipientForm.find('textarea[name="properties[Message]"]').val() || '';
          properties["Send on"] = $recipientForm.find('input[name="properties[Send on]"]').val() || '';
          properties["__shopify_offset"] = $recipientForm.find('input[name="properties[__shopify_offset]"]').val() || '';
          properties["__Selected image"] = $recipientForm.find('input[name="properties[Selected image]"]').val() || '';
        }
        queueAddToCartNotification(id);
        CartJS.addItem(id, quantity, properties);
        console.log(quantity + " of " + id + " added to cart with properties: ", properties);
    }
    e.preventDefault();
  });
  $(document).on('click', '.buy-now-button', function(e) {
    console.log('buy-now click');
    originalText = $(this).val();
    $(this).val('Updating...');
    $(this).addClass('updating');
    if ($(this).hasClass('product-table')) {
      console.log('buy now from product table - this object:');
      console.log(this)
      var qInput = $(this).parent().parent().find('input.quantity');
      var id =  qInput.attr('id');
      var quantity = qInput.val();
      var shippingRestriction = $('span.shipping-restriction');
    } else {
      console.log('buy now from product page - this object:');
      console.log(this)
      var id =  $(this).parent().parent().find('option:selected').val();
      var quantity = $(this).parent().parent().find('input.quantity').val();
      var shippingRestriction = $(this).parent().parent().parent().parent().find('p.shipping-restriction');
      // var selectedVariant = $(this).parent().parent().find('option:selected');
      // console.log('selected variant is: ', selectedVariant);
      var exStock = $(this).parent().parent().find('option:selected').attr('data-ex-oversell');
      var properties = {};
      // if (exStock !== undefined) {
      //   console.log('exStock value is: ' + exStock);
      // }
    }
    if (quantity > 0) {
      // var properties = {};
      if (exStock !== undefined) { 
        properties["_make-item"] = "TRUE"; 
      }
      if (shippingRestriction.length > 0) {
        properties["Shipping Restriction"] = "USA";
      }

      //refactor so we are just checking the properties object for the shipping restriction and ex-stock values instead of re-querying the dom for these values here
      if (properties["Shipping Restriction"] === "USA" || properties["_make-item"] === "TRUE") {
        CartJS.addItem(id, quantity, properties);
        if (properties["Shipping Restriction"] === "USA") {
          console.log('restricted item');
        }
          if (properties["_make-item"] === "TRUE") {
          console.log('ex-stock item');
        }
      } else {
        CartJS.addItem(id, quantity);
      }
      console.log(quantity + " of " + id + " added to cart");
      // $(this).val('Success!');
    }
    e.preventDefault();
  });
  var freebieRemoved = false;
  $(document).on('click', '.cart-remove', function(e) {
    if ($(this).hasClass('main-cart')) {
      $(this).closest('tr').fadeOut("slow");
      if($(this).hasClass("freebie-remove")) {
        console.log('removing freebie and setting var to prevent re-add...');
        freebieRemoved = true;
      }
    } else {
      $(this).closest('li').fadeOut("slow");
    }
  });
  $(document).on('click', 'span.add', function() {
    $(this).prev().val(+$(this).prev().val() + 1);
  });
  $(document).on('click', 'span.sub', function() {
      if ($(this).next().val() > 0) {
        $(this).next().val(+$(this).next().val() - 1);
      }
  });
  $(document).on('click', '.cart-ajax-quantity-change', function() {
    var updateLine = $(this).attr("data-cart-line");
    var updateQuant = $(this).attr("data-cart-quantity");
    var maxQuant = $(this).attr("data-adjusted-inventory");
    //convert to integer
    updateQuant = parseInt(updateQuant, 10);
    maxQuant = parseInt(maxQuant, 10);
    if (updateQuant <= maxQuant) {
      CartJS.updateItem(updateLine, updateQuant);
      $('.cart-checkout .wcs-btn').text('').append('<div class="loader"></div>');
    } else {
      console.log('max quantity reached for this item');
      console.log('max quantity is: ' + maxQuant);
      console.log('requested quantity is: ' + updateQuant);
      alert('No additional quantity available for this item');
      $(this).closest('.cart-item').find('.quantity input').val(maxQuant);
    }

  });
  $(document).on('change', '#cart-wrap .quantity input', function() {
    var updateLine = $(this).attr("data-cart-line");
    var updateQuant = $(this).val();
    CartJS.updateItem(updateLine, updateQuant);
    $(this, '#cart-wrap #cart-buttons input[name=checkout]').replaceWith('<div class="loader-wrap"><div class="loader"></div></div>');
  });
  $(document).on('cart.requestComplete', function(event, cart) {
    console.log('cart updated');
    syncKlevuProductCards(cart);
    if ( $('.add-or-update-button').length ) {
      // $('.add-or-update-button').val('Success!');
      if ($.fancybox && $.fancybox.getInstance()) {
        $.fancybox.close();
      };
    };
    if ($('.buy-now-button.updating').length) {
      console.log('buy now button updated');
      $('.buy-now-button.updating').val('ADDED!');
      $('.buy-now-button.updating').addClass('added');
      setTimeout(() => {
        console.log("This ran after 1 second!");
        console.log('original text is: ' + originalText);
         $('.buy-now-button.updating').val(originalText);
        $('.buy-now-button.updating').removeClass('updating');
        $('.buy-now-button.added').removeClass('added');
      }, 2000);
    }
    if ( $( "#cart-wrap form" ).length ) {
      $("#cart-wrap .cart-table").load("/cart?view=ajax #cart-wrap .cart-table>*","");
      $("#cart-wrap #subtotal-wrap").load("/cart?view=ajax #cart-wrap #subtotal-wrap>*", function() { window.Klarna.OnsiteMessaging.refresh(); })
      $("#offCanvas #inner").load("/?view=cartdrawer");
      // updateGiftMessage();
      // updateShippingMessage();
    } else {
      // $("#cart-drop").load("/?view=cartdrop",function() {
      //   console.log('cart dropdown refreshed');
      //   $( '#cart-drop' ).addClass( "show" );
      //   cart_hide = setTimeout(function () {
      //       $('#cart-drop').removeClass("show");
      //   }, 3000);
      //   $('.add-or-update-button').val('Add To Cart');
      //   $('.buy-now-button').val('Buy Now');
      //   $('.buy-now-button.product-table').val('Add To Cart');
      // });
      //Cart Drawer
      $("#offCanvas #inner").load("/?view=cartdrawer",function() {
        console.log('cart drawer refreshed');
        window.Klarna.OnsiteMessaging.refresh();
        $('.cart-checkout .wcs-btn').each(function(){
          $(this).text($(this).data('text')).remove('.cart-checkout .wcs-btn .loader');
        });
        var giftcard_in_cart = false;
        CartJS.cart.items.forEach(function(item, index) { //check for gift card and disable checkout button for Rise error debug
          if (item.vendor == 'Rise.ai') {
            console.log('gift card found hiding checkout');
            giftcard_in_cart = true;
          }
        })
        if (giftcard_in_cart) {
          $('#cart-drawer-checkout').hide();
        } else {
          $('#cart-drawer-checkout').show();
        }
        if (typeof tippy === "function") {
          // Initialize Tippy Tooltips
          tippy('[data-tippy-content]', {
            animation: 'perspective'
          });
        } else {
          console.error('Tippy is not loaded yet');
        }
        var dataOffcanvas = $('#offCanvas').data('offcanvas-component');
        // updateGiftMessage();
        // updateShippingMessage();
        if (!mobileSize.matches) {
          // dataOffcanvas.open();
        }
        if (originalText && originalText != "") {
          $('.add-or-update-button').val(originalText);
          // $('.buy-now-button').val(originalText);
          $('.buy-now-button.product-table').val(originalText);
          // $('.buy-now-button').val(originalText);
        }
        // $('.add-or-update-button').val('Add To Cart');
        // $('.buy-now-button').val('Buy Now');
        // $('.buy-now-button.product-table').val('Add To Cart');
      });
    };
    var itemCount = CartJS.cart.item_count;
    var $cartIcon = $('.nav-cart'); 
    var $countBadge = $('.nav-cart .item-count');

    // 1. Start the badge shrink
    $countBadge.addClass('shrink-out').one('animationend', function(e) {
        if (e.target !== this) return;

        // 2. Update count and start grow
        $(this).removeClass('shrink-out').html(itemCount).addClass('grow-in');
    });

    // 3. Listen for the badge to finish growing
    $countBadge.one('animationend', function(e) {
        if (!$(this).hasClass('grow-in')) return;
        $(this).removeClass('grow-in');

        // 4. Trigger the Wobble on the parent
        $cartIcon.addClass('wobble');
    });

    // 5. Separate listener for the parent wobble to ensure removal
    $cartIcon.on('animationend', function(e) {
        if (e.target === this) {
            $(this).removeClass('wobble');
        }
    });

      // New add to cart notification
      const isProductPage = window.location.pathname.indexOf('/products/') > -1;
      if (shouldShowAddToCartNotification && isProductPage && cart && Array.isArray(cart.items)) {
        const variantMatches = pendingAddToCartVariantId === null || cart.items.some(function(item) {
          return normalizeVariantId(item.id) === pendingAddToCartVariantId;
        });

        if (variantMatches) {
          const bar = document.getElementById('add-to-cart-notification');
          const titleEl = document.getElementById('product-title-insert');
          const productTitleSource = document.getElementById('product-title');

          if (bar && titleEl && productTitleSource) {
            titleEl.textContent = productTitleSource.textContent.trim();

            // Scroll to top smoothly
            window.scrollTo({ top: 0, behavior: 'smooth' });

            // Delay showing the bar until scroll starts (or optionally wait ~300ms)
            setTimeout(() => {
              bar.style.opacity = '0';
              bar.style.display = 'block';

              requestAnimationFrame(() => {
                bar.style.transition = 'opacity 0.3s ease';
                bar.style.opacity = '1';
              });

               // ---- Add-on injection starts here ----
// helper goes here
function resolveSelectedVariantId() {
  const fields = Array.from(document.querySelectorAll('[name="id"]'));
  const getValue = (el) =>
    el?.tagName === 'SELECT' ? el.options?.[el.selectedIndex]?.value : el?.value;
  for (const f of fields) {
    const val = getValue(f);
    if (val && window.FREE_ADDON_BY_VARIANT?.[String(val)]) return String(val);
  }
  const primary = document.querySelector('form[action*="/cart/add"] [name="id"]');
  const primaryVal = getValue(primary);
  if (primaryVal) return String(primaryVal);
  const keys = Object.keys(window.FREE_ADDON_BY_VARIANT || {});
  if (keys.length === 1) return keys[0];
  return null;
}

try {
  const offerRoot   = document.getElementById('free-addon-offer');
  const imgLinkEl   = document.getElementById('free-addon-image-link');
  const imgEl       = document.getElementById('free-addon-image');
  const titleLinkEl = document.getElementById('free-addon-title');
  const descriptionEl = document.getElementById('free-addon-description');
  const btnEl       = document.getElementById('free-addon-button');
  const noteEl      = document.getElementById('free-addon-note');

  if (offerRoot && window.FREE_ADDON_BY_VARIANT) {
    const selectedVariantId = resolveSelectedVariantId();
    const addon = selectedVariantId
      ? window.FREE_ADDON_BY_VARIANT[selectedVariantId]
      : null;

    // NEW: hide if the add-on variant is already in the cart
    const items = (cart && cart.items) ? cart.items : (window.CartJS && CartJS.cart && CartJS.cart.items) ? CartJS.cart.items : [];
    const addonAlreadyInCart = addon
      ? items.some(i => String(i.variant_id) === String(addon.variantId) && i.quantity > 0)
      : false;

    if (addon && !addonAlreadyInCart) {
      // Populate UI
      imgEl.src = addon.image;
      imgEl.alt = addon.productTitle;
      const lightboxSrc = addon.imageLarge || addon.image;
      if (imgLinkEl) {
        imgLinkEl.href = lightboxSrc || '#';
        if (addon.productTitle) {
          imgLinkEl.setAttribute('data-caption', addon.productTitle);
        } else {
          imgLinkEl.removeAttribute('data-caption');
        }
      }
      if (titleLinkEl) {
        titleLinkEl.textContent = addon.productTitle || '';
        titleLinkEl.href = lightboxSrc || '#';
        if (addon.productTitle) {
          titleLinkEl.setAttribute('data-caption', addon.productTitle);
        } else {
          titleLinkEl.removeAttribute('data-caption');
        }
      }

      if (descriptionEl) {
        const snippet = addon.descriptionSnippet;
        if (snippet) {
          descriptionEl.textContent = snippet;
          descriptionEl.hidden = false;
        } else {
          descriptionEl.textContent = '';
          descriptionEl.hidden = true;
        }
      }

      if (!addon.available) {
        btnEl.disabled = true;
        btnEl.textContent = 'Out of stock';
        noteEl.hidden = false;
        noteEl.textContent = 'This free gift is currently unavailable.';
      } else {
        btnEl.disabled = false;
        btnEl.textContent = 'Add to cart';
        noteEl.hidden = true;
        noteEl.textContent = '';
      }

      // Wire the Add button -> add the gift by variant id
      // Wire the Add button -> add the gift by variant id
btnEl.onclick = async () => {
  if (btnEl.disabled) return;

  btnEl.disabled = true;
  btnEl.textContent = 'Adding...';

  // If CartJS is present, use it so cart.requestComplete fires normally
  if (window.CartJS && typeof CartJS.addItem === 'function') {
    // Hide the offer once the cart finishes refreshing
    $(document).one('cart.requestComplete', function (_ev, cartObj) {
      btnEl.textContent = 'Added!';
      // Only allow 1 unit — hide after success
      setTimeout(() => { offerRoot.hidden = true; }, 400);
    });

    // Tag it as a free gift (optional, but handy for visibility in cart)
    CartJS.addItem(addon.variantId, 1, { "_free_gift": "TRUE" });
    return;
  }

  // Fallback if CartJS isn't available: use fetch, then trigger the same event
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: addon.variantId, quantity: 1, properties: { "_free_gift": "TRUE" } }] })
    });

    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err?.description || 'Failed to add gift');
    }

    // Pull fresh cart and trigger your normal refresh path
    const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    const freshCart = await cartRes.json();

    // Fire the same event your site already listens for
    $(document).trigger('cart.requestComplete', [freshCart]);

    btnEl.textContent = 'Added!';
    setTimeout(() => { offerRoot.hidden = true; }, 400);
  } catch (e) {
    btnEl.disabled = false;
    btnEl.textContent = 'Add to cart';
    noteEl.hidden = false;
    noteEl.textContent = e.message || 'Could not add the free gift.';
  }
};


      // Reveal the block
      offerRoot.hidden = false;
      offerRoot.classList.remove('hidden');
    } else {
      // No gift for this variant OR already present in cart
      offerRoot.hidden = true;
      offerRoot.classList.add('hidden');
      if (imgLinkEl) {
        imgLinkEl.href = '#';
        imgLinkEl.removeAttribute('data-caption');
      }
      if (titleLinkEl) {
        titleLinkEl.textContent = '';
        titleLinkEl.href = '#';
        titleLinkEl.removeAttribute('data-caption');
      }
      if (descriptionEl) {
        descriptionEl.textContent = '';
        descriptionEl.hidden = true;
      }
    }
  }
} catch (e) {
  console.warn('Free add-on render error:', e);
}
// ---- Add-on injection ends here ----

              // // Auto-hide after 5s
              // setTimeout(() => {
              //   bar.style.opacity = '0';
              //   setTimeout(() => bar.style.display = 'none', 300);
              // }, 5000);
            }, 300); // adjust delay if needed
          }
        }
      }
      // End of new add to cart notification

      shouldShowAddToCartNotification = false;
      pendingAddToCartVariantId = null;
  
    if(!freebieRemoved) {
      // handleFreeGifts();
    }
  });


  //Shipping Calculator
  if ( $( "#shipping-calculator" ).length ) {
    console.log('Loading shipping calc...');
    Shopify.Cart.ShippingCalculator.show( {
      submitButton: theme.strings.shippingCalcSubmitButton,
      submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
      customerIsLoggedIn: theme.strings.shippingCalcCustomerIsLoggedIn,
      moneyFormat: theme.strings.shippingCalcMoneyFormat
    } );
  }

  //Search Page Resources link
  if ($('span.search-select').length > 0 ) {
    console.log('search page!');
    searchString = getParameterByName('q');
    console.log("searched for: " + searchString);
    $('a.search-resources').attr('href', 'https://westcoastseeds-dev.myshopify.com/search?q='+searchString+'&type=article&view=blog');
    $('a.search-products').attr('href', 'https://westcoastseeds-dev.myshopify.com/search?q='+searchString+'');
  }

  //Mobile Search Form
  $("#mobile-nav .search-drop").on('click', function(e) {
    $('#mobile-search').toggleClass("hidden");
    e.preventDefault();
  })

  //Mobile catalog size toggle
  $('div.catalog-wrap div#mobile-options img.size-toggle').on('click', function() {
    $('div.catalog-product-grid').toggleClass('wide');
  })

  //Newsletter Signup popup submit
  $('.newsletter-signup-form').on('submit', function(e) {
   e.preventDefault();
   var $form = $(this);
   var method = $(this).attr('method');
   var action = $(this).attr('action');
   var data = $(this).serialize();
   $.ajax(
   {
     type: method,
     url: action,
     data: data
   }).done(function(response)
   {
     //console.log(response);
     $("<p class='form-success'>Thanks! You're now subscribed!</p>").insertBefore($form)
     $form.hide();

   }).fail(function(msg)
   {
     //console.log(msg);
     $("<p class='form-error'>Please enter a valid email address.</p>").insertBefore($form)
   });
   return false;
 })
 $('#what-type-of-gardener-are-you').on('change', function() {
   var $tags_input = $(this).siblings('.customer-birthday-tags');
   var tags = $tags_input.attr('data-additional-tags');
   if (tags != '') tags = tags + ',';
   $tags_input.val(tags + 'Gardener Type: ' + this.value);
 });

  //conditional loading of megamenus
  var mobileSize = window.matchMedia( "(max-width: 600px)" );
  if (mobileSize.matches) {
   console.log("mobile size!")
  } else if (!mobileSize.matches) {
   console.log("not mobile size!")
  } else {
   console.log('size detection issue...')
  }
  if (!mobileSize.matches) {
  //  getMegamenuShopAjax();
  //  getMegamenuResourcesAjax();
  }
  // getMegamenuMobileAjax();
  // console.log('up shipping');

});

//Cart JS init callback
$(document).on('cart.ready', function(event, cart) {
  console.log("CartJS Initilized");
  // updateGiftMessage();
  // updateShippingMessage();
});

//Offcanvas cart drawer init callback
$( document ).on( "create.offcanvas", function(e) {
  console.log("off canvas drawer initialized")
  // console.log(e.target);
  e.target.classList.remove('hide');
  // console.log(e.target);
});
$( document ).on( "open.offcanvas", function(e){
  $('#gorgias-chat-container #chat-button, #gorgias-chat-container #chat-window').css('transform', 'translateX(calc(-24em))')
});
$( document ).on( "close.offcanvas", function(e){
  $('#gorgias-chat-container #chat-button, #gorgias-chat-container #chat-window').css('transform', 'translateX(0)')
});

$(window).on('load',function() {

  //Hero Caption fade
  // $('.home-hero .slide-caption').removeClass('hidden');

  // var mobileSize = window.matchMedia( "(max-width: 600px)" );
  // if (mobileSize.matches) {
  //   console.log("mobile size!")
  // } else if (!mobileSize.matches) {
  //   console.log("not mobile size!")
  // } else {
  //   console.log('size detection issue...')
  // }
  // if (!mobileSize.matches) {
  //   getMegamenuShopAjax();
  //   getMegamenuResourcesAjax();
  // }
  // getMegamenuMobileAjax();

  // HANDLE NEWSLETTER MODAL
  /*
  */
  // Cookies.remove('newsletter-modal-shown');
  // Cookies.remove('pageviews-for-newsletter-modal');

  // handleNewsletterModal();
  function handleNewsletterModal() {
    var newsletter_modal_delay = 1500;
    var show_signup_on_page = 0;
    var newsletter_modal_shown = Cookies.get('newsletter-modal-shown');
    var modal_on_page = $('#newsletter-modal').length;
    if (newsletter_modal_shown || modal_on_page == 0) {
      return;
    }
    var pageviews = parseInt(Cookies.get('pageviews-for-newsletter-modal'));
    if (!pageviews || pageviews > show_signup_on_page) pageviews = 0;
    console.log('pageviews: ' + pageviews)
    if (pageviews >= show_signup_on_page) {
      setTimeout(function() {
        $.fancybox.open({
        	src  : '#newsletter-modal',
        	type : 'inline',
        	opts : {
        		afterShow : function( instance, current ) {
        			console.info( 'popup shown!' );
        		}
        	}
        });
        Cookies.set('newsletter-modal-shown', true, { expires: 3 });
      }, 2000);
    }
    pageviews++;
    Cookies.set('pageviews-for-newsletter-modal', pageviews);
  }

  handleProductAlertModal()
  function handleProductAlertModal() {
    var newsletter_modal_delay = 1500;
    var show_signup_on_page = 0;
    var newsletter_modal_shown = Cookies.get('product-modal-shown'); 
    var modal_on_page = $('#newsletter-modal').length;
    if (newsletter_modal_shown || modal_on_page == 0 ) {
      console.log('no popup');
      return;
    }
    // var pageviews = parseInt(Cookies.get('pageviews-for-newsletter-modal'));
    // if (!pageviews || pageviews > show_signup_on_page) pageviews = 0;
    // console.log('pageviews: ' + pageviews)
    // if (pageviews >= show_signup_on_page) {
      setTimeout(function() {
        $.fancybox.open({
        	src  : '#newsletter-modal',
        	type : 'inline',
        	opts : {
        		afterShow : function( instance, current ) {
        			console.info( 'popup shown!' );
        		}
        	}
        });
        Cookies.set('product-modal-shown', true, { expires: 1 });
      }, 500);
    // }
    // pageviews++;
    // Cookies.set('pageviews-for-newsletter-modal', pageviews);
  }

  //Mega Menu Preload Thumbnails
  // var imgList = [];
  // $('.menu-body a').each(function() {
  //   imgList.push($(this).data('thumb'));
  // });
  // slate.Image.preload(imgList);
  // for (var i = 0; i < imgList.length; i++) {
  //   var imgLoad = new Image();
  //   imgLoad.onload = function () {
  //     console.log("thumbnail preloaded!");
  //   }
  //   imgLoad.src = imgList[i];
  // }
});

document.addEventListener('DOMContentLoaded', function() {
  // Ensure Tippy is defined before trying to initialize it
  if (typeof tippy === "function") {
    // Initialize Tippy Tooltips
    tippy('[data-tippy-content]', {
      animation: 'perspective'
    });
  } else {
    console.error('Tippy is not loaded yet');
  }
});

//Function to detect if in iFrame (theme editor)
function inIframe () {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

//Quick Shop AJAX population
function populateQuickshop(product_url) {
  $.ajax({
      type: 'GET',
      url: product_url + ".json",
      dataType: 'json',
      success: function(res){
          console.log(res);
       },
      error: function(status){
           alert(status);
      }
  })
}

//AJAX Filter Pagination Testing
function getFilterProducts(tag){
  $.ajax({
      type: 'GET',
      url: '/products.json?limit=250',
      dataType: 'json',
      success: function(res){
          filterProducts(res.products, tag)
       },
      error: function(status){
           alert(status);
      }
  })
}

function filterProducts(products, tag) {
  var filteredProducts = products.filter(function(product){
      return product.tags.indexOf(tag) > -1;
  });
  console.log(filteredProducts);
}

//get JSON converted from HTML rendered by custom collection template
function getFilterProductsAjax(tag){
  $.ajax({
      type: 'GET',
      url: '/collections/vegetable-seeds/blend?view=ajax',
      dataType: 'html json',
      success: function(res){
        console.log(res);
          filterProducts(res.products, tag);
       },
      error: function(status){
           alert(status);
      }
  })
}

//get filtered products from json and create the elements in DOM
function getFilterCreate(tag) {
  var currUrl =  removeURLParameter(window.location.href, 'page');
  var searchUrl = "";
  if (currUrl.indexOf("?") > 0) {
    var baseUrl = currUrl.substring(0, currUrl.indexOf("?"));
    var query = new URL(currUrl).search;
    searchUrl = baseUrl + "/" + tag + query + "&view=ajax-fullhtml";
  } else {
    searchUrl = currUrl + "/" + tag + "?view=ajax-fullhtml";
  }
  console.log("filter search string: " + searchUrl);
  $.ajax({
      type: 'GET',
      url: searchUrl,
      dataType: 'html json',
      success: function(res){
        console.log(res);
        $.each(res['products'], function(index, item) {
          console.log("filter found: " + res['products'][index]['title']);
          var url = res['products'][index]['url'];
          var bg = res['products'][index]['image'];
          var title = res['products'][index]['title'];
          var price = res['products'][index]['price'];
          var buynow = res['products'][index]['buynow'];
          var markup = res['products'][index]['markup'];
          createCatProduct(url, bg, title, price, markup, buynow, tag);
        });
        $('.catalog-filters-wrap label').each(function() {
          var tag = $(this).attr('data-url');
          if($.inArray(tag, res['tags']) == -1) {
            $(this).addClass("hidden");
            $(this).parent().addClass("hidden");
          } else {
            $(this).removeClass("hidden");
            $(this).parent().removeClass("hidden");
          };
        });
        hideShowFilterBlocks();
        refreshYotpo();
      },
    error: function(status){
         alert(status);
    }
  })
}

//create new product div
function createCatProduct(url, bg, title, price, markup, buynow, tag) {
  var divCont  = "<div class='catalog-product filtered "+tag+"'>";
  var divOv = "<div class='catalog-product-overlay' style='background: linear-gradient( rgba(0, 0, 0, 0.35), rgba(0, 0, 0, 0.35) ), url("+bg+") no-repeat center center / cover'>";
  var qShop = "<a class='quick-shop-launch' data-fancybox data-type='ajax' data-src='"+url+"?view=quickshop' data-filter='#shopify-section-product-quickshop' data-animation-effect='zoom-in-out' href='javascript:;'>Quick Shop</a>"
  var divTit = "<p class='catalog-title'><a href='"+url+"'>"+title+"</a></p>";
  var divPrice = "<p class='catalog-price'>From $"+price+"</p>";
  var divClose1 = "</div>";
  var markup = markup;
  var buynow = buynow;
  var divClose2 = "</div>";

  var div = //divCont    +
                        //divOv     +
                            //qShop       +
                            //divTit       +
                            //divPrice       +
                        //divClose1 +
                        //buynow +
                      //divClose2 +
                      markup;
  $('.catalog-product-grid').append(div);
}

//createCatProduct("/collections/vegetable-seeds/products/blade-organic","//cdn.shopify.com/s/files/1/0011/2341/8172/products/MS558_Stellaria-Chickweed-Seeds_300x.jpg?v=1523420213","Stellaria Thing", "100.20")

//Ajax get articles
// function getFilterCreateArticles(tag) {
//   var currUrl =  removeURLParameter(window.location.href, 'page');
//   if (currUrl.indexOf('/tagged/') != -1 ) {
//     console.log('on a tag filtered page');
//     ajaxTarget = currUrl+"+"+tag+'?view=ajax';
//     console.log('ajax endpoint (tag page): ' + ajaxTarget);
//   } else {
//     console.log('on root page');
//     ajaxTarget = currUrl+"/tagged/"+tag+'?view=ajax';
//     console.log('ajax endpoint (root page): ' + ajaxTarget);
//   };
//   $.ajax({
//       type: 'GET',
//       url: ajaxTarget,
//       dataType: 'html json',
//       success: function(res){
//         console.log(res);
//         $.each(res['articles'], function(index, item) {
//           console.log("filter found: " + res['articles'][index]['title']);
//           var date = res['articles'][index]['date'];
//           var url = res['articles'][index]['url'];
//           var bg = res['articles'][index]['image'];
//           var title = res['articles'][index]['title'];
//           if (res['articles'][index]['excerpt'] != "") {
//             var excerpt = res['articles'][index]['excerpt'];
//           } else {
//             var excerpt = res['articles'][index]['content'];
//           }
//           createArticle(date, url, bg, title, excerpt);
//         });
//         $('label').each(function() {
//           var tag = $(this).attr('data-url');
//           if($.inArray(tag, res['tags']) == -1) {
//             $(this).addClass("hidden");
//             $(this).parent().addClass("hidden");
//           } else {
//             $(this).removeClass("hidden");
//             $(this).parent().removeClass("hidden");
//           };
//         });
//         hideShowFilterBlocks();
//       },
//     error: function(status){
//          alert(status);
//     }
//   })
// }

// function createArticle(date, url, bg, title, excerpt, tag) {
//   var divCont  = "<div class='catalog-product filtered "+tag+"'>";
//   var divOv = "<div class='catalog-product-overlay' style='background: linear-gradient( rgba(0, 0, 0, 0.35), rgba(0, 0, 0, 0.35) ), url("+bg+") no-repeat center center / cover'>";
//   var divInfo = "<div class='article-info'><p class='catalog-title'><a href='"+url+"'>"+title+"</a></p><p class='article-date'>"+date+"</p></div>";
//   var divExcerpt = "<div class='article-excerpt'><p>"+excerpt+"</p><a class='button read-more' href='"+url+"'>Continue Reading</a></div>";
//   var divOvClose = "</div>";
//   var divMobileOpen = "<div class='mobile-article mobile'>";
//   var divMobileClose = "</div>";
//   var divClose1 = "</div>";
//   var divClose2 = "</div>";

//   var div = divCont    +
//                         divOv     +
//                             divInfo       +
//                             divExcerpt       +
//                             divOvClose +
//                             divMobileOpen +
//                             divInfo +
//                             divExcerpt +
//                             divMobileClose +
//                         divClose1 +
//                       divClose2;
//   $('.catalog-product-grid').prepend(div);
// }

//test concatenating paginated results
function getFilterProductsPages(tag) {
  $.ajax({
      type: 'GET',
      url: '/products.json?limit=250',
      dataType: 'json',
      success: function(data1) {
        $.ajax({
            type: 'GET',
            url: '/products.json?limit=250&page=2',
            dataType: 'json',
            success: function(data2) {
                // data1.push.apply(data1,data2)
                // data1.push.apply(data1,data2);
                console.log(data1);
                console.log(data2);
                var finalList = $.extend(true, data1, data2)
                // console.log(finalList);
             },
            error: function(status) {
                 alert(status);
            }
        })
       },
      error: function(status) {
           alert(status);
      }
  })
}

//Hide Empty Filter Blocks
function hideShowFilterBlocks () {
  $('.catalog-filters .filter-block').each(function () {
  	console.log($(this).children('ul').children('li:not(.hidden)').length);
    if ($(this).children('ul').children('li:not(.hidden)').length < 1) {
      $(this).hide();
    } else if ($(this).css('display') == 'none' ) {
      $(this).show();
    }
  });
}

//Get Query Strings
function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

//remove specific url query strings
function removeURLParameter(url, parameter) {
    //prefer to use l.search if you have a location/link object
    var urlparts = url.split('?');
    if (urlparts.length >= 2) {
        var prefix = encodeURIComponent(parameter) + '=';
        var pars = urlparts[1].split(/[&;]/g);
        //reverse iteration as may be destructive
        for (var i = pars.length; i-- > 0;) {
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }
        return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
    }
    return url;
}

//Get Megamenu via AJAX
function getMegamenuAjax(){
  $.ajax({
      type: 'GET',
      url: '/?view=megamenu',
      dataType: 'html',
      success: function(res){
        $("#mega-menu").html(res);
        console.log("megamenu fetched");
       },
      error: function(status){
           alert(status);
      }
  })
}

function getMegamenuShopAjax(){
  $.ajax({
      type: 'GET',
      url: '/?view=megamenushop',
      dataType: 'html',
      success: function(res){
        $("#mega-menu #shop-menu").html(res);
        console.log("shop menu fetched");
       },
      error: function(status){
        console.log('shop menu not fetched. Error below:');
        console.log(status);
      }
  })
}

function getMegamenuResourcesAjax(){
  $.ajax({
      type: 'GET',
      url: '/?view=megamenuresources',
      dataType: 'html',
      success: function(res){
        $("#mega-menu #resources-menu").html(res);
        console.log("resources menu fetched");
       },
      error: function(status){
        console.log('resources menu not fetched. Error below:');
        console.log(status);
      }
  })
}

function getMegamenuMobileAjax(){
  $.ajax({
      type: 'GET',
      url: '/?view=megamenumobile',
      dataType: 'html',
      success: function(res){
        $("#mobile-menu").html(res);
        $("#mobile-menu").mmenu({
           // options
           "navbar": {
             "title": ""
           },
           "navbars": [
             {
              "position": "top",
              "type": "tabs",
              "content": [
               "<a href='#panel-shop'>Shop</a>",
               "<a href='#panel-ourstory'>Explore</a>",
               "<a href='#panel-resources'>Resources</a>"
              ]
            },
            {
              "position": "top",
              "content": [
                "prev",
                "title",
                "close"
              ]
            }
          ],
          "dividers": {
            "add": true,
            "addTo": "#mm-1,#mm-2,#mm-3,#mm-10,#mm-13"
          },
          "sectionIndexer": true,
          "extensions": [
            "fullscreen",
            "fx-menu-fade",
            "theme-white"
          ]
        }, {
           // configuration
           offCanvas: {
            pageSelector: "#MainContent"
           }
        });

        var api = $("#mobile-menu").data("mmenu");

        $('.mobile-nav-trigger').click(function() {
          api.open();
          $(this).attr('href', '#MainContent');
          $('div#shopify-section-header .nav-header').addClass('scrolled');
        });
        console.log("mobile menu fetched and initialized");
       },
      error: function(status){
           console.log('Mobile menu not fetched. Error below:');
           console.log(status);
      }
  })
}

//get url params
var getUrlParameter = function getUrlParameter(sParam, targetUrl) {
    if (typeof targetUrl !== 'undefined') {
      var parser = document.createElement('a');
      parser.href = targetUrl;
      var sPageURL = parser.search.substring(1),
          sURLVariables = sPageURL.split('&'),
          sParameterName,
          i;
    } else {
      var sPageURL = window.location.search.substring(1),
          sURLVariables = sPageURL.split('&'),
          sParameterName,
          i;
    }

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
};

//simulate event -- i.e. click
function eventFire(el, etype){
  if (el.fireEvent) {
    el.fireEvent('on' + etype);
  } else {
    var evObj = document.createEvent('Events');
    evObj.initEvent(etype, true, false);
    el.dispatchEvent(evObj);
  }
}

//Init Ajaxinate (formerly Ajaxify) for endless click
document.addEventListener("DOMContentLoaded", function() {
  var endlessScroll = new Ajaxinate({
    container: '.EndlessClick',
    pagination: '.endless-click-button',
    method: 'click',
    callback: refreshYotpo
  });
});

function refreshYotpo() {
  var api = new Yotpo.API(yotpo);
  api.refreshWidgets();
  console.log("Yotpo refreshed");
}

//TEMP FIX FOR GEOTARGED POPUP APP
// $(window).on('load', function() {
//     waitForElm("#popup-9880").then(e=>{
//         console.log("GEOPOP DISPLAYED"),
//         Cookies.set("ppkcookie-9880", !0, {
//             expires: 1
//         }),
//         console.log("GEOPOP cookie set!"),
//         document.addEventListener("click", function(t) {
//             t.target && (t.target.classList.contains("slickOverlay") || t.target.innerText == "SHOP SEEDLINGS") && (console.log("GEOPOPUP close"),
//             e.style.display = "none")
//         })
//     }
//     )
// });
// function waitForElm(e) {
//     return new Promise(t=>{
//         if (document.querySelector(e))
//             return t(document.querySelector(e));
//         const a = new MutationObserver(o=>{
//             document.querySelector(e) && (t(document.querySelector(e)),
//             a.disconnect())
//         }
//         );
//         a.observe(document.body, {
//             childList: !0,
//             subtree: !0
//         })
//     }
//     )
// }

//FREE GIFT LOGIC
function handleFreeGifts() {
	console.log('checking gift setup...')
	// $(document).on('cart.ready', function(event, cart) {
		// var cartState = CartJS.cart;
    var giftMessageDiv = document.getElementById('free-gift-message');
		var cartObject = jQuery.getJSON('/cart.js', function(data) {
			var cartState = cartObject.responseJSON;
			console.log('state total: ' + cartState.total_price);
            var requiresShipping = cartState.requires_shipping;
            if (!requiresShipping) {
              console.log('no shipping required, skipping/removing free gifts...');
              return false;
            }
      var freebiesActive = false;
			freebieSettings.reverse().forEach(function (tier, index) {
				// console.log(tier)
				if (freebieSettings[index].enabled) {
          freebiesActive = true;
					var threshold = freebieSettings[index].threshold;
					var giftProdId = freebieSettings[index].giftProdId;
          var giftPrice = freebieSettings[index].giftPrice;
					var requiredCollection = freebieSettings[index].requiredCollection;
					if (requiredCollection) {
						console.log("required collection total: " + getCollectionSubtotal(requiredCollection));
						if ((getCollectionSubtotal(requiredCollection) - giftPrice) >= threshold && !freebieInCart2(cartState, giftProdId) && giftProdId) {
							addFreeItemToCart(freebieSettings[index].giftProdId);
							console.log('adding free gift with requirement: ', giftProdId);
						} else if ((getCollectionSubtotal(requiredCollection) - giftPrice) < threshold) {
							if (freebieInCart2(cartState, giftProdId)) {
								console.log('removing free gift with requirement: ', giftProdId);
							 removeFreeItemFromCart(giftProdId);
						 	}
						}
					} else if (giftProdId && !freebieInCart2(cartState, giftProdId)) {
            if (cartState.total_price >= threshold) {
              console.log('adding free gift: ', giftProdId);
							addFreeItemToCart(giftProdId);
            }
          } else if (giftProdId && freebieInCart2(cartState, giftProdId)) {
            if ((cartState.total_price - getFreebiePrice(cartState, giftProdId)) < threshold) {
              console.log('removing free gift 1: ', giftProdId);
              removeFreeItemFromCart(giftProdId);
            }
					}
				}
			})

      //remove all if freebies disabled
      if (!freebiesActive) {
        console.log('no free gifts active');
        removeAllFreebiesFromCart(cartState);
        giftMessageDiv.style.display = 'none';
      } 
		});
		//remove all if cart below threshold 1
		// if (cartState.total_price < freebieSettings[0].threshold) {
		// 	removeAllFreebiesFromCart();
		// }
	// });

}

function updateGiftMessage() {
  var giftMessageDiv = document.getElementById('free-gift-message');
  if (giftMessageDiv != null) {
    var cartObject = jQuery.getJSON('/cart.js', function(data) {
      cartState = cartObject.responseJSON;
      console.log(cartState.total_price);
      freebieSettings.reverse().forEach(function (tier, index) {
        // console.log(tier)
        if (freebieSettings[index].enabled) {
          freebiesActive = true;
          var threshold = freebieSettings[index].threshold;
          var giftProdId = freebieSettings[index].giftProdId;
          var giftPrice = freebieSettings[index].giftPrice;
          var requiredCollection = freebieSettings[index].requiredCollection;
          if (requiredCollection) {
            console.log("required collection total: " + getCollectionSubtotal(requiredCollection));
            if ((getCollectionSubtotal(requiredCollection) - giftPrice) >= threshold && !freebieInCart2(cartState, giftProdId) && giftProdId) {
              
            } else if ((getCollectionSubtotal(requiredCollection) - giftPrice) < threshold) {
              
            }
          } else if (cartState.total_price >= threshold) {
            giftMessageDiv.style.display = 'block';
            giftMessageDiv.textContent = `You're getting a FREE 500ml bottle of MARPHYL Soil Enhancer.`;
          } else {
            giftMessageDiv.style.display = 'block';
            giftMessageDiv.textContent = `Add $${parseFloat((threshold - cartState.total_price) / 100).toFixed(2)} more to receive a FREE 500ml bottle of MARPHYL Soil Enhancer.`;
          }
        }
      })
    });
  }
}

function updateShippingMessage() {
  var giftMessageDiv = document.getElementById('free-gift-message');
  
  if (!giftMessageDiv) {
      return;
  }

  jQuery.getJSON('/cart.js', function(cart) {
      var cartSubtotal = cart.total_price / 100; // Convert cents to dollars
      let messages = [];

      if (cartSubtotal < 79) {
          let amountForFlatRate = (79 - cartSubtotal).toFixed(2);
          messages.push(`<p><span class="money">$${amountForFlatRate}</span> more for <span class="free-text text-green-dark">FREE</span> Flat Rate Shipping 🚚</p>`);
      } else if (cartSubtotal >= 79 && cartSubtotal < 125) {
          messages.push("<p>🎉 You're getting <span class=\"free-text text-green-dark\">FREE</span> Flat Rate Shipping!</p>");
      }

      if (cartSubtotal < 125) {
          let amountForExpedited = (125 - cartSubtotal).toFixed(2);
          messages.push(`<p><span class="money">$${amountForExpedited}</span> more for <span class="free-text text-green-dark">FREE</span> Expedited Shipping 🚀</p>`);
      } else if (cartSubtotal >= 125) {
          messages.push("<p>🎉 You're getting <span class=\"free-text text-green-dark\">FREE</span> Expedited Shipping!</p>");
      }

      giftMessageDiv.classList.add('tiered-free-shipping');
      giftMessageDiv.innerHTML = messages.join('');
      giftMessageDiv.style.display = 'flex';
  });
}



function updateGeoRestrictedShippingMessage() {
  // console.log('upshipping')
  // Helper function to make the API call and process the response
  function checkGeoLocationAndUpdateMessage() {
      var userLocation = sessionStorage.getItem('userLocation');
      // console.log('location: ', userLocation)
      if (!userLocation) {
        // console.log('fetching location...');
          var url = "https://ipgeolocation.abstractapi.com/v1/?api_key=913bd8de005a4e1a8e1bbb6ef7b1da8e";
          httpGetAsync(url, function(response) {
              var data = JSON.parse(response);
              // console.log('geodata: ')
              // console.log(data);
              if (data.region === "British Columbia") {
                  sessionStorage.setItem('userLocation', 'BC');
                  updateCartAlert(true);
              } else {
                  sessionStorage.setItem('userLocation', 'Other');
                  // updateCartAlert(false);
              }
          });
      } else {
          updateCartAlert(userLocation === 'BC');
      }
  }

  // Update the cart alert based on the user's location
  function updateCartAlert(isInBC) {
      // console.log('location check: ', isInBC)
      var giftMessageDiv = document.getElementById('free-gift-message');
      var alertTextDiv = document.querySelector('#alert-bar .alert-text');

      if (!isInBC) {
        return;
      }
      
      if (isInBC && alertTextDiv) {
        console.log('update alert');
        alertTextDiv.innerHTML = "<p>FREE Shipping on seeds and live goods for orders with minimum $70 before tax (hard goods excluded, BC addresses only)</p>";
      }

      if (!isInBC || !giftMessageDiv) {
        // console.log('missing?');
          return;
      }

      jQuery.getJSON('/cart.js', function(cart) {
          var cartSubtotal = cart.total_price;
          if (cartSubtotal >= 7000) { // Assuming the subtotal is in cents
              giftMessageDiv.innerHTML = "You're getting FREE shipping on seeds/live-goods to BC";
              // alertTextDiv.innerHTML = "<p>FREE Shipping on seeds and live goods for orders with minimum $70 before tax (hard goods excluded)</p>";
          } else {
              var amountRemaining = (7000 - cartSubtotal) / 100; // Convert cents to dollars
              giftMessageDiv.innerHTML = `$${amountRemaining.toFixed(2)} more for FREE shipping on seeds/live-goods to BC`;
              // alertTextDiv.innerHTML = ""; // Optionally clear or update this message for non-qualifying totals
          }
          giftMessageDiv.style.display = 'block';
      });
  }
  // Helper function for making API calls
  function httpGetAsync(url, callback) {
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.onreadystatechange = function() {
          if (xmlHttp.readyState === 4 && xmlHttp.status === 200)
              callback(xmlHttp.responseText);
      };
      xmlHttp.open("GET", url, true); // true for asynchronous
      xmlHttp.send(null);
  }

  checkGeoLocationAndUpdateMessage();
}

function getCollectionSubtotal(prodHandle) {
	var collectionTotal = 0;
	$('.cart-item').each(function(item) {
		var collectionString  = $(this).data('collections')
		var collectionArray = []
		if (collectionString) {
			collectionArray = collectionString.split(',');
			if (collectionArray.includes(prodHandle)) {
				collectionTotal = collectionTotal + $(this).data('line-price');
			}
		}
	});
	return collectionTotal;
}

function freebieInCart(prodId) {
	var cartState = CartJS.cart;
	var match = false;
	cartState.items.forEach(function (item, index) {
		if (item.id == prodId && item.properties.Freebie) {
			console.log('Found matching freebies');
			match = true;
		}
	});
	return match;
}

function freebieInCart2(cartState, prodId) {
	var match = false;
	cartState.items.forEach(function (item, index) {
		if (item.id == prodId && item.properties.Freebie) {
			console.log('Found matching freebies');
			match = true;
		}
	});
	return match;
}

function getFreebiePrice(cartState, prodId) {
  let freebiePrice = 0;
	cartState.items.forEach(function (item, index) {
		if (item.id == prodId && item.properties.Freebie) {
			// console.log('Found matching freebies');
			freebiePrice = item.final_line_price;
		}
	});
	return freebiePrice;
}

function anyFreebieInCart(cartState) {
    var match = false;
    cartState.items.forEach(function (item, index) {
        if (item.properties.Freebie) {
            console.log('Freebie present...');
            match = true;
        }
    });
    return match;
}

function addFreeItemToCart(prodId) {
	CartJS.addItem(prodId, 1, {
    "Freebie": "True"
  });
}

function removeFreeItemFromCart(prodId) {
	var cartState = CartJS.cart;
	cartState.items.forEach(function (item, index) {
		if (item.id == prodId && item.properties.Freebie) {
			console.log('REMOVING FREEBIE, item ' + index);
			CartJS.removeItem(index + 1);
		}
	});
}

function removeAllFreebiesFromCart(cartState) {
	console.log('removing all freebies!!')
	cartState.items.forEach(function (item, index) {
		if (item.properties.Freebie) {
			console.log('FREEBIE FOUND, item ' + index);
			CartJS.removeItem(index + 1);
		}
	});
}

//* SPROUT INJECTION *//
//*chatbot injection to gorgias**//
var sproutPopupDisplayed = false;
var sproutPopupClosed = localStorage.getItem('sproutPopupClosed') === 'true';

function isSproutGorgiasInjectionEnabled() {
  return !window.theme ||
    !window.theme.sproutChat ||
    window.theme.sproutChat.enableGorgiasInjection !== false;
}

var initGorgiasChatPromise = window.GorgiasChat ? window.GorgiasChat.init() : new Promise(function(resolve) {
  window.addEventListener('gorgias-widget-loaded', function() {
    resolve();
    console.log('Gorgias widget loaded');
    if (!isSproutGorgiasInjectionEnabled()) {
      return;
    }
    setTimeout(function() {
      if (window.GorgiasChat && GorgiasChat.isOpen()) {
        console.log('Gorgias widget already open');
        injectCustomButtonAndIframe();
      }
      // createSproutDebugButton();
    }, 500); // Delay the resolution to ensure everything is loaded
    var initialScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    var oneThirdPageHeight = document.documentElement.scrollHeight / 3;
    function checkScrollDistance() {
      if (sproutPopupDisplayed || sproutPopupClosed) {
        return; // No need to check if the popup is already shown or closed
      }
      var currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      var scrollDistance = Math.abs(currentScrollPosition - initialScrollPosition);
      if (scrollDistance >= oneThirdPageHeight) {
        triggerChatAnimationAndPopup();
        sproutPopupDisplayed = true;
      }
    }
    // window.addEventListener('scroll', checkScrollDistance);
  });
});

initGorgiasChatPromise.then(function() {
  // Listen for the widget opening to inject the custom button and iframe
  if (!isSproutGorgiasInjectionEnabled() || !window.GorgiasChat || !GorgiasChat.on) {
    return;
  }
  GorgiasChat.on('widget:opened', function(data) {
    console.log('widget opened');
    injectCustomButtonAndIframe();
  });
});

let directSprout = false;

//attention grab animation/popup
function triggerChatAnimationAndPopup() {
  if (!isSproutGorgiasInjectionEnabled()) {
    return;
  }

  var chatButtonIframe = document.getElementById('chat-button');
  if (!chatButtonIframe) {
    return;
  }
  // Wobble animation
  chatButtonIframe.classList.add('wobble');
  setTimeout(() => {
    chatButtonIframe.classList.remove('wobble');
  }, 1000); // Duration of wobble animation
  // Create and style popup element
  var popup = document.createElement('div');
  popup.id = 'sproutPop';
  popup.style.cssText = `
    display: flex;
    align-items: center;
    position: fixed;
    padding: 15px 10px 10px 10px;
    border-radius: 8px;
    background-color: white;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    max-width: calc(100vw - 80px);
    opacity: 0; // Start hidden
    z-index: 1;
  `;
  // Add text content to popup
  var textContent = document.createElement('div');
  var sproutAlertTexts = ["Question? Try asking our chatbot, Sprout.", "Hi, I'm Sprout. Ask me your gardening questions!"]
  textContent.textContent = sproutAlertTexts[Math.floor(Math.random() * sproutAlertTexts.length)];
  popup.appendChild(textContent);
  // Add image to popup
  var img = document.createElement('img');
  img.src = "https://cdn.shopify.com/s/files/1/0011/2341/8172/files/Icon_Sprout_soft.svg?v=1704474553";
  img.style.width = '25px'; // Adjust the size as needed
  img.style.marginLeft = '10px'; // Space between image and text
  popup.appendChild(img);
  // Append popup to the body first to calculate its dimensions
  document.body.appendChild(popup);
  var rect = chatButtonIframe.getBoundingClientRect();
  var buttonCenter = rect.left + rect.width / 2; // Center of the button
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  // Popup tail positioned on the right side
  var tail = document.createElement('div');
  tail.style.cssText = `
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid white;
    position: absolute;
    bottom: -10px;
    right: 10px; // Adjust for tail position from the right edge of the popup
      `;
  popup.appendChild(tail);
    // Position the popup so that the tail is centered over the button
  var tailCenter = buttonCenter; // Adjust if needed
  popup.style.left = `${tailCenter - popup.offsetWidth + 20}px`; // 20px is approximately the width of the tail
  popup.style.top = `${rect.top + scrollTop - popup.offsetHeight - 5}px`; // Include scroll offset

  // Calculate and set the initial position of the popup
  function positionPopup() {
    var rect = chatButtonIframe.getBoundingClientRect();
    var buttonCenter = rect.left + (rect.width / 2);
    // Adjust left position so that tail is centered over the button
    var tailPositionFromRight = 20; // Tail width and its position from the right edge
    var popupLeftPosition = buttonCenter - (popup.offsetWidth - tailPositionFromRight);
    popup.style.left = `${popupLeftPosition}px`;
    popup.style.top = `${rect.top - popup.offsetHeight - 10}px`; // Position above the button
  }
  positionPopup(); // Position popup initially
  // Fade in animation
  popup.style.animation = 'fadeIn 0.25s ease-in-out forwards';
  // Add close button (X) to the popup
  var closeButton = document.createElement('div');
  closeButton.textContent = 'X';
  closeButton.style.cssText = `
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    padding: 5px;
    font-size: 12px;
    color: black;
  `;
  popup.appendChild(closeButton);
  // Add event listener to close button for fade out
  closeButton.addEventListener('click', function() {
    popup.style.animation = 'fadeOut 0.25s ease-in-out forwards';
    setTimeout(() => {
      document.body.removeChild(popup);
      localStorage.setItem('sproutPopupClosed', 'true');
      sproutPopupClosed = true;
    }, 250); // Delay matches the duration of the fade-out animation
  });
}

function injectCustomButtonAndIframe(attempt) {
  if (!isSproutGorgiasInjectionEnabled()) {
    return;
  }

  attempt = attempt || 0;

  // Use a delay to ensure the iframe document is fully ready
  setTimeout(function() {
    var iframe = document.getElementById('chat-window');
    if (!iframe) {
      if (attempt < 8) {
        injectCustomButtonAndIframe(attempt + 1);
      }
      return;
    }

    var iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
    if (!iframeDoc || !iframeDoc.body) {
      if (attempt < 8) {
        injectCustomButtonAndIframe(attempt + 1);
      }
      return;
    }

    window.globalChatFrameDoc = iframeDoc;
    doInjection(iframeDoc);

    if (attempt < 5) {
      injectCustomButtonAndIframe(attempt + 1);
    }
  }, 250); // Delay this to give time for the iframe's content to fully load
}

function doInjection(iframeDoc) {
  if (!isSproutGorgiasInjectionEnabled()) {
    return;
  }

  injectCustomButtonStyles(iframeDoc);
  var gorgiasPanel = findGorgiasChatPanel(iframeDoc);
  var floatingHeader = iframeDoc.getElementById('conversation-floating-header');
  markGorgiasBrandBackground(iframeDoc, floatingHeader);
  injectSproutTabs(iframeDoc, gorgiasPanel, floatingHeader);
  injectSproutCloseButton(iframeDoc, gorgiasPanel || iframeDoc.body);

  var existingIframe = iframeDoc.querySelector('.gardenbot-iframe');
  if (!existingIframe) {
    var mountTarget = gorgiasPanel || iframeDoc.body;
    var gardenbotWrap = iframeDoc.createElement('div');
    gardenbotWrap.className = 'gardenbot-iframe-wrap';
    var gardenbotIframe = iframeDoc.createElement('iframe');
    gardenbotIframe.src = "https://wcs-gardenbot-fe.fly.dev/";
    gardenbotIframe.title = "Sprout gardening assistant";
    gardenbotIframe.className = 'gardenbot-iframe';
    gardenbotIframe.setAttribute('allow', 'clipboard-write');
    gardenbotIframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    gardenbotWrap.appendChild(gardenbotIframe);
    mountTarget.appendChild(gardenbotWrap);

    gardenbotIframe.onload = function() {
      console.log('gardenbot iframe loaded');
      if (directSprout == true) {
        openGbot(iframeDoc, true);
        directSprout = false;
      }
    };

    console.log('Injected sprout frame');
    listenForSproutLoaded(gardenbotIframe);
  } else {
    var existingWrap = existingIframe.closest('.gardenbot-iframe-wrap');
    var iframeMountTarget = gorgiasPanel || iframeDoc.body;

    if (!existingWrap) {
      existingWrap = iframeDoc.createElement('div');
      existingWrap.className = 'gardenbot-iframe-wrap';
      existingIframe.parentNode.insertBefore(existingWrap, existingIframe);
      existingWrap.appendChild(existingIframe);
    }

    if (existingWrap.parentNode !== iframeMountTarget) {
      iframeMountTarget.appendChild(existingWrap);
    }

    listenForSproutLoaded(existingIframe);
  }
}

function injectCustomButtonStyles(iframeDoc) {
  // Check if the custom styles already exist
  var existingStyles = iframeDoc.getElementById('custom-ai-assistant-styles');
  if (!existingStyles) {
    // Create a new style element
    var styleEl = iframeDoc.createElement('style');
    styleEl.id = 'custom-ai-assistant-styles';
    styleEl.textContent = `
      :root {
        --sprout-gorgias-tab-height: 54px;
        --sprout-gorgias-panel-offset: 24px;
        --sprout-gorgias-sprout-padding: 16px;
        --sprout-gorgias-content-offset: 28px;
      }
      body {
        --sprout-gorgias-header-height: 0px;
      }
      body.sprout-tabs-body-mounted {
        box-sizing: border-box !important;
        padding-top: var(--sprout-gorgias-panel-offset) !important;
      }
      body.sprout-tabs-body-mounted > #mountHere,
      body.sprout-tabs-body-mounted > .frame-root {
        box-sizing: border-box !important;
        height: calc(100vh - var(--sprout-gorgias-panel-offset)) !important;
        max-height: calc(100vh - var(--sprout-gorgias-panel-offset)) !important;
        min-height: calc(100vh - var(--sprout-gorgias-panel-offset)) !important;
      }
      .sprout-gorgias-panel {
        box-sizing: border-box !important;
        overflow: hidden !important;
        position: relative !important;
      }
      .sprout-gorgias-brand-background {
        background: #416b38 !important;
      }
      .sprout-gorgias-brand-background > [size] {
        opacity: 0 !important;
        visibility: hidden !important;
      }
      .sprout-gorgias-tabs {
        align-items: center;
        background: #fff;
        border-bottom: 1px solid rgba(65, 107, 56, 0.22);
        box-sizing: border-box;
        display: flex;
        gap: 0;
        height: var(--sprout-gorgias-tab-height);
        overflow: hidden;
        padding: 0;
        position: relative;
        width: 100%;
        z-index: 2147483646;
      }
      body.sprout-tabs-body-mounted .sprout-gorgias-tabs {
        left: 0;
        position: fixed;
        right: 0;
        top: 0;
      }
      body.sprout-tabs-panel-mounted .sprout-gorgias-tabs {
        border-radius: inherit;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        flex: 0 0 var(--sprout-gorgias-tab-height);
      }
      body.sprout-tabs-header-mounted .sprout-gorgias-tabs {
        margin-top: 0;
      }
      .sprout-gorgias-floating-header {
        margin-top: 0 !important;
        top: var(--sprout-gorgias-tab-height) !important;
      }
      body.sprout-gardening-active .sprout-gorgias-floating-header {
        pointer-events: auto !important;
        visibility: visible !important;
        z-index: 2147483647 !important;
      }
      body.sprout-gardening-active .sprout-gorgias-floating-header #header-view-cart-button,
      body.sprout-gardening-active .sprout-gorgias-floating-header button[aria-label="Track orders"] {
        pointer-events: none !important;
        visibility: hidden !important;
      }
      body.sprout-tabs-panel-mounted #conversation-floating-header button[aria-label="Close"],
      body.sprout-tabs-header-mounted #conversation-floating-header button[aria-label="Close"],
      body.sprout-tabs-body-mounted #conversation-floating-header button[aria-label="Close"] {
        pointer-events: none !important;
        visibility: hidden !important;
      }
      body:not(.sprout-gardening-active) .sprout-gorgias-conversation-wrap,
      body:not(.sprout-gardening-active) #homepage-header {
        box-sizing: border-box !important;
        margin-top: var(--sprout-gorgias-content-offset) !important;
      }
      .sprout-gorgias-tab {
        align-items: center;
        appearance: none;
        background: transparent;
        border: 0;
        border-radius: 0;
        color: #2f332d;
        cursor: pointer;
        display: flex;
        flex: 1 1 0;
        font-family: inherit;
        font-size: 13px;
        font-weight: 700;
        height: 100%;
        justify-content: center;
        line-height: 1.15;
        min-width: 0;
        padding: 0 8px;
        text-align: center;
      }
      .sprout-gorgias-tab + .sprout-gorgias-tab {
        border-left: 1px solid rgba(65, 107, 56, 0.12);
      }
      .sprout-gorgias-tab:first-child {
        border-top-left-radius: inherit;
      }
      .sprout-gorgias-tab:last-child {
        border-top-right-radius: inherit;
      }
      .sprout-gorgias-tab[aria-selected="true"] {
        background: #416b38;
        color: #fff;
      }
      .sprout-gorgias-tab:focus {
        outline: none;
      }
      .sprout-gorgias-tab:focus-visible {
        box-shadow: inset 0 0 0 2px rgba(65, 107, 56, 0.28);
      }
      .gardenbot-iframe {
        background: #fff;
        border: 0;
        box-sizing: border-box;
        display: block;
        height: 100%;
        width: 100%;
      }
      .gardenbot-iframe-wrap {
        background: #fff;
        bottom: 0;
        box-sizing: border-box;
        display: none;
        height: calc(100vh - var(--sprout-gorgias-tab-height));
        left: 0;
        padding: 0 var(--sprout-gorgias-sprout-padding);
        position: fixed;
        right: 0;
        top: var(--sprout-gorgias-tab-height);
        width: 100%;
        z-index: 2147483645;
      }
      body.sprout-tabs-panel-mounted .gardenbot-iframe-wrap {
        bottom: 0;
        height: calc(100% - var(--sprout-gorgias-tab-height));
        left: 0;
        padding: 0 var(--sprout-gorgias-sprout-padding);
        position: absolute;
        right: 0;
        top: var(--sprout-gorgias-tab-height);
        width: 100%;
      }
      body.sprout-tabs-header-mounted .gardenbot-iframe-wrap {
        bottom: 0;
        height: calc(100% - var(--sprout-gorgias-tab-height));
        left: 0;
        padding: 0 var(--sprout-gorgias-sprout-padding);
        position: absolute;
        right: 0;
        top: var(--sprout-gorgias-tab-height);
        width: 100%;
      }
      body.sprout-tabs-body-mounted.sprout-gardening-active > *:not(.sprout-gorgias-tabs):not(.gardenbot-iframe-wrap):not(.sprout-gardenbot-close):not(#custom-ai-assistant-styles) {
        pointer-events: none !important;
        visibility: hidden !important;
      }
      body.sprout-gardening-active .gardenbot-iframe-wrap {
        display: block !important;
      }
      .sprout-gardenbot-close {
        display: none;
        position: absolute;
        right: var(--sprout-gorgias-sprout-padding);
        top: calc(var(--sprout-gorgias-tab-height) + 20px);
        z-index: 2147483647;
      }
      body.sprout-tabs-panel-mounted .sprout-gardenbot-close,
      body.sprout-tabs-header-mounted .sprout-gardenbot-close,
      body.sprout-tabs-body-mounted .sprout-gardenbot-close,
      body.sprout-gardening-active .sprout-gardenbot-close {
        display: block;
      }
      @media screen and (max-width: 390px) {
        .sprout-gorgias-tab {
          font-size: 12px;
          padding: 0 6px;
        }
      }
    `;
     // Add wobble and popup CSS
      var wobbleAndPopupStyles = `
      @keyframes wobble {
        0%, 100% { transform: rotate(-5deg); }
        50% { transform: rotate(5deg); }
      }
      #chat-button.wobble {
        animation: wobble 0.5s ease-in-out;
      }
      .popup {
        position: absolute;
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%) scale(0);
        transition: transform 0.3s ease-in-out;
        /* Add other popup styles here */
      }
      .popup.visible {
        transform: translateX(-50%) scale(1);
      }
    `;

    styleEl.textContent += wobbleAndPopupStyles;
    iframeDoc.head.appendChild(styleEl);
  }
}

function injectSproutCloseButton(iframeDoc, mountTarget) {
  var existingCloseButton = iframeDoc.querySelector('.sprout-gardenbot-close');
  if (existingCloseButton) {
    if (existingCloseButton.parentNode !== mountTarget) {
      mountTarget.appendChild(existingCloseButton);
    }

    return existingCloseButton;
  }

  var closeButtonWrap = iframeDoc.createElement('div');
  closeButtonWrap.className = 'sprout-gardenbot-close';
  closeButtonWrap.innerHTML = '<span class="message-window-iframe-wwiaj0"><button shape="circle" role="button" aria-label="Close" class="message-window-iframe-kg6lnn"><div class="message-window-iframe-14hehf9"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path stroke="#1E242E" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.4 18.2 12.2 12m0 0L6 5.8m6.2 6.2 6.2-6.2M12.2 12 6 18.2"></path></svg></div></button></span>';
  closeButtonWrap.querySelector('button').addEventListener('click', function() {
    closeGorgiasWidget(iframeDoc);
  });
  mountTarget.appendChild(closeButtonWrap);

  return closeButtonWrap;
}

function injectSproutTabs(iframeDoc, gorgiasPanel, floatingHeader) {
  var existingTabs = iframeDoc.querySelector('.sprout-gorgias-tabs');
  if (existingTabs) {
    mountSproutTabs(iframeDoc, existingTabs, gorgiasPanel, floatingHeader);
    return existingTabs;
  }

  var tabs = iframeDoc.createElement('div');
  tabs.className = 'sprout-gorgias-tabs';
  tabs.setAttribute('role', 'tablist');
  tabs.setAttribute('aria-label', 'Chat options');

  var customerSupportTab = createSproutTab(iframeDoc, 'Customer Support', true);
  var gardeningTab = createSproutTab(iframeDoc, 'Gardening Questions', false);

  customerSupportTab.addEventListener('click', function() {
    closeGbot(iframeDoc);
  });

  gardeningTab.addEventListener('click', function() {
    openGbot(iframeDoc, true);
  });

  tabs.appendChild(customerSupportTab);
  tabs.appendChild(gardeningTab);
  mountSproutTabs(iframeDoc, tabs, gorgiasPanel, floatingHeader);

  return tabs;
}

function markGorgiasBrandBackground(iframeDoc, floatingHeader) {
  var header = floatingHeader || iframeDoc.getElementById('conversation-floating-header');
  if (!header || !header.parentElement || !iframeDoc.defaultView) {
    return;
  }

  var current = header.parentElement;
  while (current && current !== iframeDoc.body) {
    var styles = iframeDoc.defaultView.getComputedStyle(current);
    var backgroundImage = styles.backgroundImage || '';

    if (backgroundImage.indexOf('linear-gradient') !== -1) {
      current.classList.add('sprout-gorgias-brand-background');
      return;
    }

    current = current.parentElement;
  }
}

function mountSproutTabs(iframeDoc, tabs, gorgiasPanel, floatingHeader) {
  if (gorgiasPanel) {
    var headerHeight = floatingHeader ? Math.ceil(floatingHeader.getBoundingClientRect().height || 48) : 0;
    iframeDoc.body.style.setProperty('--sprout-gorgias-header-height', floatingHeader ? headerHeight + 'px' : '0px');
    iframeDoc.body.classList.add('sprout-tabs-panel-mounted');
    iframeDoc.body.classList.remove('sprout-tabs-header-mounted');
    iframeDoc.body.classList.remove('sprout-tabs-body-mounted');
    if (floatingHeader) {
      floatingHeader.classList.add('sprout-gorgias-floating-header');
      var conversationWrap = findGorgiasContentAfterHeader(floatingHeader);
      if (conversationWrap) {
        conversationWrap.classList.add('sprout-gorgias-conversation-wrap');
      }
    }
    gorgiasPanel.classList.add('sprout-gorgias-panel');

    if (tabs.parentNode !== gorgiasPanel) {
      gorgiasPanel.insertBefore(tabs, gorgiasPanel.firstChild);
    } else if (tabs !== gorgiasPanel.firstElementChild) {
      gorgiasPanel.insertBefore(tabs, gorgiasPanel.firstChild);
    }

    return;
  }

  iframeDoc.body.classList.add('sprout-tabs-body-mounted');
  iframeDoc.body.classList.remove('sprout-tabs-header-mounted');
  iframeDoc.body.classList.remove('sprout-tabs-panel-mounted');

  if (tabs.parentNode !== iframeDoc.body) {
    iframeDoc.body.appendChild(tabs);
  }
}

function findGorgiasContentAfterHeader(floatingHeader) {
  var current = floatingHeader;

  while (current && current.parentElement) {
    if (current.nextElementSibling) {
      return current.nextElementSibling;
    }

    current = current.parentElement;
  }

  return null;
}

function findGorgiasChatPanel(iframeDoc) {
  var floatingHeader = iframeDoc.getElementById('conversation-floating-header');
  if (floatingHeader && floatingHeader.closest) {
    var headerDialog = floatingHeader.closest('[role="dialog"]');
    if (headerDialog) {
      return headerDialog;
    }
  }

  var previousPanel = iframeDoc.querySelector('.sprout-gorgias-panel');
  if (previousPanel && previousPanel.getBoundingClientRect().height > 0) {
    return previousPanel;
  }

  var candidates = Array.prototype.slice.call(iframeDoc.body.querySelectorAll('*'));
  var bestCandidate = null;
  var bestScore = 0;

  candidates.forEach(function(element) {
    if (element.classList.contains('sprout-gorgias-tabs') || element.classList.contains('gardenbot-iframe')) {
      return;
    }

    var rect = element.getBoundingClientRect();
    if (rect.width < 280 || rect.height < 360 || rect.top < 0 || rect.left < 0) {
      return;
    }

    var styles = iframeDoc.defaultView.getComputedStyle(element);
    var radius = parseFloat(styles.borderTopLeftRadius) || 0;
    var hasChatSurface = isLightChatSurface(styles.backgroundColor);
    var hasRoundedPanel = radius >= 12;

    if (!hasChatSurface && !hasRoundedPanel) {
      return;
    }

    var score = rect.width + rect.height + (hasRoundedPanel ? 300 : 0) + (hasChatSurface ? 120 : 0);

    if (score > bestScore) {
      bestScore = score;
      bestCandidate = element;
    }
  });

  return bestCandidate;
}

function isLightChatSurface(color) {
  var match = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
  if (!match) {
    return false;
  }

  return parseInt(match[1], 10) > 235 && parseInt(match[2], 10) > 235 && parseInt(match[3], 10) > 235;
}

function createSproutTab(iframeDoc, label, isSelected) {
  var tab = iframeDoc.createElement('button');
  tab.type = 'button';
  tab.className = 'sprout-gorgias-tab';
  tab.setAttribute('role', 'tab');
  tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
  tab.textContent = label;
  return tab;
}

function setSproutTabState(iframeDoc, isGardeningActive) {
  var tabs = iframeDoc.querySelectorAll('.sprout-gorgias-tab');
  if (tabs.length < 2) {
    return;
  }

  tabs[0].setAttribute('aria-selected', isGardeningActive ? 'false' : 'true');
  tabs[1].setAttribute('aria-selected', isGardeningActive ? 'true' : 'false');
}

function listenForSproutLoaded(gardenbotIframe) {
  if (gardenbotIframe.dataset.sproutLoadedListenerAttached === 'true') {
    return;
  }

  gardenbotIframe.dataset.sproutLoadedListenerAttached = 'true';
  window.addEventListener('message', function(message) {
    if (message.source !== gardenbotIframe.contentWindow) {
      return;
    }

    var data = message.data;
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (error) {
        return;
      }
    }

    if (data && data.message === 'sprout-loaded') {
      sendSproutCustomerContext(gardenbotIframe);
    }
  });
}

function sendSproutCustomerContext(gardenbotIframe) {
  var sproutCustomerContext = window.sproutCustomer || null;
  if (!sproutCustomerContext) {
    return;
  }

  gardenbotIframe.contentWindow.postMessage(
    JSON.stringify({ loggedinCustomer: sproutCustomerContext }),
    'https://wcs-gardenbot-fe.fly.dev'
  );
}

// Function to be called when the custom button is clicked
function openGbot(iframeDoc, forceOpen) {
  var gardenbotIframe = iframeDoc.querySelector('.gardenbot-iframe');
  var gardenbotWrap = iframeDoc.querySelector('.gardenbot-iframe-wrap');
  var sproutPop = document.getElementById('sproutPop');
  localStorage.setItem('sproutPopupClosed', 'true');
  sproutPopupDisplayed = true;
  sproutPopupClosed = true;

  if (gardenbotIframe && gardenbotWrap) {
    var isIframeHidden = window.getComputedStyle(gardenbotWrap).display === 'none';
    var shouldOpen = forceOpen || isIframeHidden;
    gardenbotWrap.style.display = shouldOpen ? 'block' : 'none';
    iframeDoc.body.classList.toggle('sprout-gardening-active', shouldOpen);
    setSproutTabState(iframeDoc, shouldOpen);

    if(sproutPop) {
      sproutPop.style.display = 'none';
    }
  }
}

function closeGbot(iframeDoc) {
  var gardenbotIframe = iframeDoc.querySelector('.gardenbot-iframe');
  var gardenbotWrap = iframeDoc.querySelector('.gardenbot-iframe-wrap');
  if (gardenbotIframe && gardenbotWrap) {
    gardenbotWrap.style.display = 'none';
    iframeDoc.body.classList.remove('sprout-gardening-active');
    setSproutTabState(iframeDoc, false);
  }
}

function closeGorgiasWidget(iframeDoc) {
  if (window.GorgiasChat && GorgiasChat.close) {
    GorgiasChat.close();
    return;
  }

  var nativeCloseButton = iframeDoc.querySelector('#conversation-floating-header button[aria-label="Close"]');
  if (nativeCloseButton) {
    nativeCloseButton.click();
  }
}

// function createSproutDebugButton() {
//   console.log('adding sprout debug button')
//   var debugButton = document.createElement('button');
//   debugButton.textContent = 'Trigger Sprout Alert';
//   debugButton.style.cssText = `
//     position: fixed;
//     right: 20px;
//     top: 50%;
//     transform: translateY(-50%);
//     padding: 10px 15px;
//     background-color: #416B38;
//     color: white;
//     border: none;
//     border-radius: 5px;
//     cursor: pointer;
//     z-index: 1000; // Ensure it's above other elements
//   `;
//   debugButton.addEventListener('click', function() {
//     triggerChatAnimationAndPopup();
//   });

//   var debugButton2 = document.createElement('button');
//   debugButton2.textContent = 'Reset Sprout Alert Close';
//   debugButton2.style.cssText = `
//     position: fixed;
//     right: 20px;
//     top: 50%;
//     transform: translateY(calc(-50% + 50px));
//     padding: 10px 15px;
//     background-color: #416B38;
//     color: white;
//     border: none;
//     border-radius: 5px;
//     cursor: pointer;
//     z-index: 1000; // Ensure it's above other elements
//   `;
//   debugButton2.addEventListener('click', function() {
//     localStorage.removeItem('sproutPopupClosed');
//     window.location.reload();
//   });

//   document.body.appendChild(debugButton);
//   document.body.appendChild(debugButton2);
//   console.log('added sprout debug button')
// }

function directOpenSprout() {
  if (!isSproutGorgiasInjectionEnabled()) {
    return;
  }

  if (!window.GorgiasChat || !GorgiasChat.open) {
    return;
  }

  directSprout = true;
  GorgiasChat.open();
}

//* END SPROUT INJECTION *//
//set body padding to to height of nav header
// Update body padding or padding-top of the correct div based on conditions
function updateBodyPadding() {
  const maxWidth = 2650; // Example: Apply only for screen widths <= 768px

   // Check if the current screen width meets the condition
   if (window.innerWidth > maxWidth) {
    // Reset padding if the condition is not met
    console.log('reset padding')
    resetPadding();
    return;
  }
  // Get the sticky header element
  let header = document.getElementById('shopify-section-header');
  if (header) {
      // Get the height of the header
      let headerHeight = header.offsetHeight;

      if (document.body.classList.contains('nohero')) {
          // For pages with 'nohero', set body padding
          document.body.style.setProperty('padding-top', `${headerHeight}px`, 'important');
          console.log('adjust hero padding');
      } else {
          // For pages without 'nohero', adjust padding of the target div
          let mainContent = document.querySelector('#MainContent');
          if (mainContent) {
              let targetDiv = findTargetDiv(mainContent);
              if (targetDiv) {
                  targetDiv.style.setProperty('padding-top', `${headerHeight + 20}px`, 'important');
                  console.log('adjust content padding');
              }
          }
      }
  }
}

// Find the target div based on specific classes
function findTargetDiv(container) {
  for (let child of container.children) {
      // Check if the child has the 'module' class or a class containing 'header-wrap'
      if (
          child.classList.contains('pt-first') || child.classList.contains('about-hero') ||
          Array.from(child.classList).some((cls) => cls.includes('header-wrap'))
      ) {
          return child; // Found the matching div
      }
      // If the child has children, search recursively
      let nestedDiv = findTargetDiv(child);
      if (nestedDiv) {
          return nestedDiv;
      }
  }
  return null; // No matching div found
}

// Reset padding styles if the screen width condition is not met
function resetPadding() {
  document.body.style.removeProperty('padding-top'); // Reset body padding
  let mainContent = document.querySelector('#MainContent');
  if (mainContent) {
      let targetDiv = findTargetDiv(mainContent);
      if (targetDiv) {
          targetDiv.style.removeProperty('padding-top'); // Reset target div padding
      }
  }
}

// Update padding on page load
document.addEventListener('DOMContentLoaded', updateBodyPadding);
// Update padding on resize or orientation change
window.addEventListener('resize', updateBodyPadding);
window.addEventListener('orientationchange', updateBodyPadding);


//END CM SCRIPTS


$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});
